<template>
    <div class="mainDialogAlert lion_alert active" :class="`toast-${position}`">
        <transition-group name="toast-slide" tag="div">
            <div
                v-for="notification in notifications"
                :key="notification.key"
                class="content"
                @click="remove(notification)"
            >
                <i class="main_icon lefticon error" v-if="notification.icon == $waringIcon.Cross"></i>
                <i class="main_icon lefticon lightcorrect" v-if="notification.icon == $waringIcon.Check"></i>
                <i class="main_icon lefticon quealert" v-if="notification.icon == $waringIcon.Exclamation"></i>
                <div v-html="notification.message"></div>
                <i class="close main_icon" @click.stop="remove(notification)"></i>
            </div>
        </transition-group>
    </div>
</template>

<script>
import toastComponent from 'BASE/components/notification/toast.component.js';
import { _plugin } from 'BASE/plugins/toastDialogPlugin.js';

export default {
    mixins: [toastComponent],
    props: {
        name: {
            type: String,
            required: true,
        },
    },
    mounted() {
        // 註冊到 dialogPlugin 的 dialogs 中
        if (_plugin && _plugin.dialogs) {
            _plugin.dialogs[this.name] = this;
        }
    },
    beforeDestroy() {
        // 從 dialogPlugin 的 dialogs 中移除
        if (_plugin && _plugin.dialogs) {
            _plugin.dialogs[this.name] = undefined;
        }
        this.clear();
    },
};
</script>